import { ModuleType } from 'modules/common/types';

export const appConfigModule: ModuleType = {
	pages: [],
};
